<template>
  <v-dialog
    v-model="openDialog"
    scrollable
    persistent
    transition="dialog-bottom-transition"
    max-width="1000"
  >
    <validation-observer v-slot="{ valid }">
      <v-card>
        <v-card-title class="headline my-3">
          Criar arquivo modelo de Caderno de Serviços
        </v-card-title>
        <v-card-text>
          <v-row class="mx-auto">
            <v-col cols="12">
              <v-alert dense outlined type="info" color="blue" class="pa-2">
                Realize a filtragem dos lançamentos que devem ir para o Caderno de Serviços
              </v-alert>
              <v-alert dense outlined type="info" color="blue" class="pa-2">
                Utilize pelo menos um filtro
              </v-alert>

              <validation-provider rules="required" immediate>
                <input type="hidden" name="valida-filtragem-minima" v-model="minOneFilterSelected">
              </validation-provider>
            </v-col>
          </v-row>

          <v-row class="mx-auto">
            <v-col cols="12">
              <validation-provider v-slot="{ errors }" rules="required|max:60" id="nome-modelo-caderno-servicos">
                <v-text-field
                  label="Nome"
                  outlined
                  :error-messages="errors"
                  v-model="nome"
                />
              </validation-provider>
            </v-col>
            <v-col cols="9">
              <v-textarea
                id="obras"
                class="pt-0 mt-0"
                label="Obras"
                v-model="filtros.obras"
                placeholder="Insira os códigos das obras, um por linha. Ex.:

      CI1944457111 
      CI1944457348"
                rows="5"
                no-resize
                clearable
                clear-icon="mdi-close-circle"
              />
            </v-col>
            <v-col id="obras-nao-pertence" class="mt-12 pl-0" cols="3">
              <v-checkbox
                class="py-0 my-0"
                hide-details
                label="Não pertence"
                v-model="filtros.obrasNaoPertencem"
              />
            </v-col>
          </v-row>

          <v-row class="mx-auto" id="data-lancamento">
            <v-col class="pb-0 pt-1" cols="5">
              <v-menu
                v-model="menuPickerImob[0]"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <validation-provider 
                    v-slot="{ errors }"
                    :rules="{required_if: filtros.dataLanc.fimFormatted != null && filtros.dataLanc.fimFormatted.length > 0, min:10}"
                  >
                    <v-text-field
                      :error-messages="errors"
                      class="pt-0"
                      v-mask="'##/##/####'"
                      v-model="filtros.dataLanc.inicioFormatted"
                      label="Data Lançamento"
                      prepend-icon="mdi-calendar"
                      clearable
                      v-bind="attrs"
                      v-on="on"
                      @blur="filtros.dataLanc.inicio = parseDate(filtros.dataLanc.inicioFormatted);"
                    />
                  </validation-provider>
                </template>
                <v-date-picker
                  v-model="filtros.dataLanc.inicio"
                  @input="menuPickerImob[0] = false; filtros.dataLanc.inicioFormatted = formatDate(filtros.dataLanc.inicio);"
                  locale="pt-br"
                />
              </v-menu>
            </v-col>
            <v-col class="text-center pt-5 pb-0" style="min-width:60px !important;" cols="2">
              <span style="color: rgba(0, 0, 0, 0.54); font-size:15px">até</span> 
            </v-col>
            <v-col class="pb-0 pt-1" cols="5">
              <v-menu
                v-model="menuPickerImob[1]"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <validation-provider 
                    v-slot="{ errors }" 
                    :rules="{required_if: filtros.dataLanc.inicioFormatted != null && filtros.dataLanc.inicioFormatted.length > 0, min:10}"
                  >
                    <v-text-field
                      :error-messages="errors"
                      class="pt-0"
                      v-mask="'##/##/####'"
                      v-model="filtros.dataLanc.fimFormatted"
                      label="Data Lançamento"
                      prepend-icon="mdi-calendar"
                      clearable
                      v-bind="attrs"
                      v-on="on"
                      @blur="filtros.dataLanc.fim = parseDate(filtros.dataLanc.fimFormatted);"
                    />
                  </validation-provider>
                </template>
                <v-date-picker
                  v-model="filtros.dataLanc.fim"
                  @input="menuPickerImob[1] = false; filtros.dataLanc.fimFormatted = formatDate(filtros.dataLanc.fim);"
                  locale="pt-br"
                />
              </v-menu>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn
            v-show="!processandoArquivoModelo"
            color="primary" text
            @click="$emit('changeValue', false)"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            :loading="processandoArquivoModelo"
            :disabled="!valid"
            @click="getArquivoPadrao()"
          >
            Criar
          </v-btn>
        </v-card-actions>
      </v-card>
    </validation-observer>
  </v-dialog>
</template>

<script>
import ModelosCadernosServicosService from "@/services/parametrosComCa/ModelosCadernosServicosService";
import DateFormatterMixins from "@/mixins/dateFormatterMixins.js";

export default {
  name: "DialogDownloadArquivo",

  mixins: [DateFormatterMixins],

  props: {
    openDialog: {
      type: Boolean,
      required: true,
    }
  },

  data() {
    return {
      menuPickerImob: [false, false],
      nome: '',
      filtros: {
        obras: "",
        obrasNaoPertencem: false,
        dataLanc: {
          inicioFormatted: '',
          inicio: '',
          fimFormatted: '',
          fim: '',
        },
      },
      processandoArquivoModelo: false,
    }
  },

  computed: {
    minOneFilterSelected() {
      return this.filtros.obras ||
        (this.filtros.dataLanc.inicio && this.filtros.dataLanc.fim)
          ? true
          : undefined;
    }
  },

  methods: {
    getArquivoPadrao() {
      this.processandoArquivoModelo = true;

      const data = {
        nome: this.nome,
        dataLancamentoInicial: this.filtros.dataLanc.inicio,
        dataLancamentoFinal: this.filtros.dataLanc.fim,
        obras: this.filtros.obras,
        obrasNaoPertencem: this.filtros.obrasNaoPertencem
      };

      ModelosCadernosServicosService.criar(data)
        .then(() => {
          this.$toast.info("Seu arquivo será gerado em breve, por favor aguarde", "", { position: "topRight", timeout: 5000 });

          this.$emit("changeValue", false); // fecha o dialog
          this.$emit("created");
        })
        .catch(err => {
          this.$toast.error("Erro ao criar arquivo modelo de Caderno de Serviços", "", { position: "topRight"});
          console.error(err);
        })
        .finally(() => this.processandoArquivoModelo = false);
    },
  }
}

</script>

<style></style>